import React, { Component } from "react";
import { ajax, unparam } from "utils/common";
import Logo from "images/logo.png";
import "./index.less";

class App extends Component {
    state = {
        corpLogo: ""
    }

    componentDidMount() {
        //展示logo
        this.setState({
            // corpLogo: location.origin + "/oivi/account/getLogo",
			corpLogo: `${location.origin}/oivi/account/logo/${localStorage.corpCode}.png`,
        })
    }

    handleImgError = () => {
        this.setState({
            corpLogo: Logo
        })
    }

    render(){
        const userName = localStorage.userName;
        const { i18n } = this.props;

        
        return (
            <div className="video-header-wrap">
                <div className="video-com-header">
                    <div className="video-com-header-lf">
                        <img src={this.state.corpLogo} onError={this.handleImgError}/>
                        <p>{i18n.systemName}</p>
                    </div>
                    <div className="video-com-header-rt">
                        <span><i className="iconfont icon-user"></i></span>
                        <span>{i18n.index.title + userName}</span>
                    </div>
                </div>
            </div>
        )
    }
}


export default App;